export const setUndeliveredGoods = (undeliveredGoods) => {
    return {
        type: "SET_UNDELIVERED_GOODS",
        payload: undeliveredGoods
    }
};
